// extracted by mini-css-extract-plugin
module.exports = {"Container":"ServiceTexts_Container__1SXu3","NoActiveServiceText":"ServiceTexts_NoActiveServiceText__rdD7B","Field":"ServiceTexts_Field__1R5fT"};